module.exports = __webpack_public_path__ + "img/img6.5ed0eb29.svg";